export default __webpack_public_path__ + "static/media/COSM492.0bc954e9.PNG";